(() => {
  if (window.HitoyasumiCartReassurance) {
    window.HitoyasumiCartReassurance.init();
    return;
  }

  const selector = '[data-cart-reassurance]';
  const allowedSurfaces = new Set(['cart_drawer', 'cart_page']);
  const initialized = new WeakSet();
  const capturedSurfaces = new Set();
  const observedCartRoots = new WeakSet();
  let subscribedToCartUpdates = false;

  function capture(node) {
    const surface = node.dataset.cartReassuranceSurface;
    if (!allowedSurfaces.has(surface) || capturedSurfaces.has(surface)) return;

    capturedSurfaces.add(surface);

    try {
      window.posthog?.capture('cart_reassurance_view', { surface });
    } catch (_error) {
      // Measurement must never interrupt cart actions or expose diagnostics.
    }
  }

  function init(root = document) {
    if (!window.IntersectionObserver) return;

    const nodes = root.querySelectorAll(selector);
    nodes.forEach((node) => {
      if (initialized.has(node)) return;

      initialized.add(node);

      const observer = new window.IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;

            capture(entry.target);
            currentObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.5 },
      );

      observer.observe(node);
    });
  }

  function subscribeToCartUpdates() {
    if (
      subscribedToCartUpdates ||
      typeof subscribe !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined' ||
      !PUB_SUB_EVENTS.cartUpdate
    ) {
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, () => init());
    subscribedToCartUpdates = true;
  }

  function observeCartReplacements() {
    if (!window.MutationObserver || !window.IntersectionObserver) return;

    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((root) => {
      if (observedCartRoots.has(root)) return;

      observedCartRoots.add(root);
      const observer = new window.MutationObserver(() => init());
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  function start() {
    observeCartReplacements();
    init();
  }

  window.HitoyasumiCartReassurance = { init };
  subscribeToCartUpdates();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  } else {
    start();
  }
})();
